module.exports = ".unavailable {\n    fill: #676767;\n}\n\n.available {\n    fill: red;\n}\n\n.selected {\n    stroke-width: 4px;\n    stroke: #343434;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project/shot-image/shots-graph/shots-graph.component.css
// module id = ./src/app/projects/project/shot-image/shots-graph/shots-graph.component.css
// module chunks = main